<template>
  <div class="intro-content">
    <v-container>

      <!-- Page 5 -->
          <h2 style="text-align:left">{{ head5 }} <span class="dod"></span></h2>

          <h3 style="text-align:left">{{ subhead5_1 }}</h3>

          <div class="listhead">Include:</div>
          <ul class="indented2">
            <li>{{ list5_1_1include }}</li>
            <li>{{ list5_1_1include1 }}</li>
            <li>{{ list5_1_2include }}</li>
            <li>{{ list5_1_3include }}</li>
            <li>{{ list5_1_4include }}</li>
            <li>{{ list5_1_5include }}</li>
            <li>{{ list5_1_6include }}</li>
            <li>{{ list5_1_7include }}</li>
          </ul>
          <div class="listhead">Do not include:</div>
          <ul class="indented2">
            <li><b>{{ list5_1_1exclude }}<u>{{ list5_1_1excludeSplit }}</u></b></li>
            <li>{{ list5_1_2exclude }}</li>
          </ul>

          <h2 style="text-align:left">{{ subhead5_2 }}</h2>

          <div class="listhead">Include:</div>
          <ul class="indented2">
            <li>{{ list5_2_1include }}</li>
            <li>{{ list5_2_2include }} <u>{{ list5_2_2_1include }}</u> {{ list5_2_2_2include }}</li>
            <li>{{ list5_2_3include }}</li>
            <li>{{ list5_2_4include }}</li>
          </ul>
          <div class="listhead">Do not include:</div>
          <ul class="indented2">
						<li>{{ list5_2_0exclude }}</li>
            <li>{{ list5_2_1exclude }}</li>
          </ul>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      head5: "Types of Funding to Include",
      subhead5_1: "R&D Conduct and RDT&E",
      list5_1_1include:
        "All your agency’s RDT&E costs (which includes R&D conduct), regardless of whether the funding was from direct appropriations, trust funds, special account receipts, or fees and charges.",
      list5_1_1include1:
        "Include RDT&E activities from all accounts, such as Military Personnel, Military Construction, Operations and Maintenance, Health and Medical, Civil Works and Engineering, and Overseas Contingency Operations.",
      list5_1_2include:
        "Agency R&D costs for non-U.S. performers.",
      list5_1_3include:
        "Costs of performing, planning, and administering RDT&E conducted by your agency, including laboratory overhead and pay of military personnel.",
      list5_1_4include:
        "For RDT&E contracts, include all of your agency’s administrative costs.",
      list5_1_5include:
        "Minor equipment purchases, such as personal computers, standard microscopes, and simple spectrometers.",
      list5_1_6include:
        "Funds transferred to another agency for R&D. These should be reported as part of the “Federal” sector for R&D performance.",
      list5_1_7include:
        "Classified R&D programs should be included in question totals. Where classified programs cannot be reported by specific state-area location of performer (questions 13–15) report amounts using the “Undistributed” category.",
      list5_1_1exclude:
        "Reimbursable funds provided to your agency by another federal agency. The originating agency will report these funds as obligations ",
      list5_1_1excludeSplit:
        "to the “Federal” sector on questions 9, 10, and 12-15.",
      list5_1_2exclude:
        "For RDT&E grants, do not include your agency’s administrative costs.",
      subhead5_2: "R&D Plant",
      list5_2_1include:
        "Funding for the construction of facilities that are necessary for the execution of an R&D program. This may include land, major fixed equipment, and supporting infrastructure such as a sewer line, or housing at a remote location. Many laboratory buildings will include a mixture of R&D facilities and office space. The fraction of the building directly related to the conduct of R&D may be calculated based on the percentage of the building’s total square footage.",
      list5_2_2include:
        "Acquisition, design, or production of major ",
			list5_2_2_1include: "moveable",
			list5_2_2_2include: " equipment, such as mass spectrometers, research vessels, DNA sequencers, and other major moveable instruments for use in R&D activities.",
      list5_2_3include:
        "Programs of $1 million or more that are devoted to the purchase or construction of R&D major equipment.",
      list5_2_4include:
        "Agency R&D plant costs for non-U.S. performers.",
			list5_2_0exclude:
				"Construction of other facilities, such as office space.",
      list5_2_1exclude:
        "Minor equipment purchases, such as personal computers, standard microscopes, and simple spectrometers (if part of an R&D activity, report these costs under R&D conduct and RDT&E, not R&D plant)."

    };
  }
};
</script>

<style scoped>

h1 {
  font-size: 22pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h2 {
  font-size: 20pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h3 {
  font-size: 18pt;
  font-weight: bold;
  margin-left: 12pt;
}
.indented1 {
  margin-left: 25pt;
  font-weight: normal;
}
.indented2 {
  margin-left: 50pt;
  font-weight: normal;
}
.indented2under {
  margin-left: 50pt;
  font-weight: normal;
  text-decoration-line: underline;
}
.bold {
  font-weight: bold;
}
.italics {
  font-style: italic;
}
.normal {
  font-weight: normal;
}
.listhead {
  margin-left: 25pt;
  text-align: left;
  text-decoration-line: underline;
  font-size: larger;
  margin-bottom: 10pt;
}
.left {
  text-align: left;
}
.centered {
  text-align: center;
}
ul,
p {
  text-align: left;
}
p,
li {
  font-size: 12pt;
}
li {
  margin-bottom: 10pt;
}
.intro-content {
  color: #000;
  max-width: 750px; /* TODO: discuss w/team; make a global */
}
.bordered {
  border: #000;
  border: 1px solid;
}
.header {
  font-weight: bold;
  color: #13314f;
  font-size: 14px;
  margin: 0;
}
table {
  background-color: aliceblue;
  width: 100%;
  text-align: left;
  border-spacing: 0;
  border: 1px solid black;
  border-collapse: collapse;
}
th {
  text-align: center;
  border: 1px solid black;
  padding: 15px;
}
.marginleft {
  margin-left: 5px;
}
td {
  border: 1px solid black;
  padding: 10px;
}
td.center {
  text-align: center;
  border: 1px solid black;
}
</style>
